/* eslint-disable class-methods-use-this */
export class Analytics {

  constructor() {
    this.partnerInfo = {};
  }

  setPartnerInfo(parnerInfo) {
    this.partnerInfo = parnerInfo;
  }

  getPartnerInfo() {
    return this.partnerInfo;
  }

  registryEvent(event) {
    window.dataLayer && window.dataLayer.push(event); //eslint-disable-line
  }
}

export default new Analytics();



// WEBPACK FOOTER //
// ./src/components/storefront/analytics/analytics.js